import { request } from "./request.js";

export async function get(key) {
    return await request("/test", { key: key }, "POST");
}

export async function save(data) {
    return await request("/test/save", data, "POST");
}

export async function list(all = false) {
    const append = all === true ? '?all' : '';
    return await request("/test/list" + append, {}, "POST");
}

export async function checkupSave(data) {
    return await request("/checkup/test", data, "POST");
}
